<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [legend]="chartOptions.legend!"
        [chart]="chartOptions.chart!"
        [labels]="chartOptions.labels!"
        [grid]="chartOptions.grid!"
        [fill]="chartOptions.fill!"
        [stroke]="chartOptions.stroke!"
        [responsive]="chartOptions.responsive!"
    ></apx-chart>
</div>